define('view/template/template.preview.page.view',['require','exports','module','blockit','formkit/formkit'],function(require, exports, module) {
  //prettier-ignore
  var BlocKit = require('blockit'),
      FormKit = require('formkit/formkit');

  var TemplateHistoryPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,

        behaviors: {
          AnswerFormRootBehavior: {
            form: '@this.form',
            behaviorClass: FormKit.Block.AnswerFormRootBehavior,
          },
        },

        pageHeader: {
          headerText: 'Form Preview',
          breadcrumbs: [
            { text: 'Forms', route: 'template:list' },
            {
              model: '@resources.revision',
              bindings: { text: 'template.name' },
              route: 'template:detail',
              params: { primaryId: '@state.templateId' },
            },
            { text: 'Form Preview' },
          ],
          actions: [
            {
              text: 'Previous',
              behaviors: {
                GoToPreviousSectionBehavior: {
                  behaviorClass: FormKit.GoToPreviousSectionBehavior,
                  form: '@this.form',
                },
              },
            },
            {
              text: 'Next',
              behaviors: {
                GoToNextSectionBehavior: {
                  behaviorClass: FormKit.GoToNextSectionBehavior,
                  form: '@this.form',
                },
              },
            },
          ],
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.ContentHeaderView,
              header: {
                behaviors: {
                  BindTextToActiveSectionTitleBehavior: {
                    form: '@this.form',
                    optionName: 'text',
                    bindValueToSectionAttribute: 'text',
                    behaviorClass: FormKit.BindOptionToActiveSectionChangeBehavior,
                  },
                },
              },
            },
            {
              type: FormKit.Block.AnswerFormObjectCollectionView,
              form: '@this.form',
            },
          ],
        },

        railColumn: {
          components: [
            {
              type: FormKit.Block.AnswerSectionMenuView,
              form: '@this.form',
            },
          ],
        },
      },
    },
  });

  module.exports = TemplateHistoryPageView;
});

